import React, {Fragment, useEffect, useState, useRef} from "react";
import mapData from '../../../assets/wojewodztwa-medium.json'
import {connect} from "react-redux";
import {MapContainer, GeoJSON} from 'react-leaflet'
import "leaflet/dist/leaflet.css";
import {GComponents} from "bizcharts";
const {
  Canvas,
} = GComponents;

const MapPlot = ({plot_data, name, start, end, value_type,title}) => {
    const [mapDataWithIndicators, setMapData] = useState(mapData);
    const [recievedData, updateData] = useState(plot_data);
    const [key, forceUpdate] = React.useState(0);
  const valueConvert = (val, prec = 2) => {
        if (typeof val === typeof 1) {

             if(value_type === " dni")
                prec = 0;

            return (Number(val).toFixed(prec)).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".", ",") + value_type

        }

        return val
    }
    const addData = (element,object) => {
        //unoptimized left for reference
        // const indicatorValue = plot_data.find((item) => {
        //     if (item.nazwa_regionu.toUpperCase() === element.properties.nazwa) {
        //         return item.median
        //     }
        // });

        const indicatorValue=object[element.properties.nazwa]





        if (indicatorValue !== undefined) {
            element.properties.indicator = indicatorValue.median;
            element.properties.normalisedIndicator = indicatorValue.normalisedIndicator;
        } else {
            element.properties.indicator = "Brak Danych";
            element.properties.normalisedIndicator = 0
        }

    };

    const reloadData = () => {
        let tmpData = mapDataWithIndicators;
        const object = plot_data.reduce((obj, item) => (obj[item.nazwa_regionu.toUpperCase()] = {median:item.median,normalisedIndicator:item.normalisedIndicator}, obj) ,{});
        [...tmpData.features].forEach((element, index, array)=>{
            addData(element,object)
        });
        setMapData(tmpData);
        forceUpdate(key + 1);
    };
    useEffect(() => {

        if (plot_data !== recievedData) {
            updateData(plot_data);
            reloadData();
        }
        else{
            reloadData();

        }
    }, [plot_data]);
    const RenderModal = (name, layer) => {
        const text = valueConvert(name.properties.indicator)
        const html = `
          <div class="voivodeship-popup">
            <h6>${name.properties.nazwa}</h6>
                <h7>Mediana: ${text}</h7> 
          </div>
        `;
        layer.bindPopup(html);
        layer.bindTooltip(text, {permanent: true,
   direction: "center",
   className: "my-labels"}).openTooltip();
        layer.options.fillOpacity = name.properties.normalisedIndicator;
        //todo fix refresh
    };

    const countryStyle = {
        fillColor: "rgb(107, 188, 212)",
        fillOpacity: 0.7,
        color: "black"
    };
    const checkIfDataExists = () =>{
        if(plot_data){
            if(plot_data.length > 0){
                return true
            }
        }
        return false
    }
        const displayTitle = ()=>{
        if((new Date(start).getMonth() === new Date(end).getMonth()) && (new Date(start).getFullYear()=== new Date(end).getFullYear()))
            return " za " + (new Date(start).getMonth() + 1) + "/" + new Date(start).getFullYear();

        return (start ? (" od " + (new Date(start).getMonth() + 1) + "/" + new Date(start).getFullYear()) : "") + (end ? (" do " + (new Date(end).getMonth() + 1) + "/" + new Date(end).getFullYear()) : "")
    }
    return (<Fragment>

            {checkIfDataExists() ? (
                <Fragment>
                    <div className={"map-title-text align-center"}>
                        <div>
                        {name + " "} {displayTitle()}
                        <br/>
                    </div>
                    <div style={{marginBottom:'10px',fontWeight:500}}>
                        {title}
                     </div>
                     </div>
                <MapContainer attributionControl={false} style={{height: "460px",backgroundColor:"white", "strokeWidth":"1"}} stroke-width="1" zoom={6.5} center={[52.00, 20.00]} maxZoom={6} minZoom={6}  zoomControl={false}
                     maxBounds={[[50, 14], [54, 25]]}>
                    <GeoJSON key={key} style={countryStyle} data={mapDataWithIndicators.features}
                             onEachFeature={RenderModal}/>

                </MapContainer>
                    </Fragment>


            ):<> Brak danych  </>
            }
        </Fragment>
    )

};
// export default IndicatorList
const mapStateToProps = state => ({
    PlotData: state.PlotData

});
export default connect(mapStateToProps, null)(MapPlot)